import React from 'react'

import { Button, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import ContactButton from 'modules/billing/components/ContactButton'
import { PlanStatus } from 'modules/billing/lib/prices'

const WithTooltip = ({ tooltip, children }: { tooltip: string; children: React.ReactNode }) => {
  const [open, toggle] = useToggle(false)

  return (
    <Tooltip.Alt
      label={tooltip}
      attachment="bottom right"
      targetAttachment="top right"
      size="small"
      open={open}
      toggle={toggle}
    >
      {children}
    </Tooltip.Alt>
  )
}

const PricingPlanSubmitButton = ({
  planStatus,
  emitEventHandler,
  disabled = false,
}: {
  planStatus: PlanStatus
  emitEventHandler: () => void
  disabled?: boolean
}) => {
  switch (planStatus) {
    case 'current':
      return (
        <WithTooltip tooltip={i18n.t('pricing_plans.tooltip_info.current_plan')}>
          <Button disabled type="secondary" submit>
            {i18n.t('pricing_plans.submit_button.current_plan')}
          </Button>
        </WithTooltip>
      )
    case 'legacy':
      return (
        <ContactButton
          disabled={disabled}
          ctaLabel={i18n.t('pricing_plans.submit_button.superior_plan')}
          contactReason="upgrade"
          emitEventHandler={emitEventHandler}
        />
      )
    default:
      return null
  }
}

export default PricingPlanSubmitButton
